import Resource from './resource-class'

class CultureMediumAPI extends Resource {
  constructor () {
    super()
    this.resource = '/culture_medium'
  }
}

export default new CultureMediumAPI()
